import { render, staticRenderFns } from "./ComplaintEdit.vue?vue&type=template&id=41afcf19&scoped=true&"
import script from "./ComplaintEdit.vue?vue&type=script&lang=js&"
export * from "./ComplaintEdit.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintEdit.vue?vue&type=style&index=0&id=41afcf19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41afcf19",
  null
  
)

export default component.exports